import React from "react";

const Bahar = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>Bahar</h2>
        <p>Content for Bahar page will go here.</p>
      </div>
    </div>
  );
};

export default Bahar;
